import { useCallback, useMemo } from 'react';
import { Keyboard, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ModalWrapper } from '@/components';
import styles from './ContentGalleryDialog.module.scss';
import { useContentGallery } from './ContentGalleryContext';

export default function ContentGalleryDialog() {
  const { selectedImage, images, setSelectedImage } = useContentGallery();
  const initialIndex = useMemo(() => {
    const index = selectedImage ? images.findIndex((img) => img.file.url === selectedImage.file.url) : 0;
    return index === -1 ? 0 : index;
  }, [selectedImage, images]);
  const close = useCallback(() => {
    setSelectedImage(null);
  }, [setSelectedImage]);

  return (
    <ModalWrapper onClose={close} className={styles.wrapper}>
      <Swiper
        modules={[Navigation, Keyboard]}
        loop
        navigation
        slidesPerView={1}
        keyboard
        centeredSlides
        onSwiper={(swiper) => swiper.slideTo(initialIndex + 1, 0, false)}
      >
        {images.map((image) => (
          <SwiperSlide key={image.file.url} onClick={(e) => e.stopPropagation()} className={styles.slide}>
            <img className={styles.image} srcSet={image.file.url} alt={image.caption} />
          </SwiperSlide>
        ))}
      </Swiper>
    </ModalWrapper>
  );
}
